import {
  Card,
  CbhIcon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { CardContent, DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { FOOTER_BUTTON_MIN_WIDTH, getTbTestChecklist, TB_TEST_UPLOAD_CALLOUT } from "../constants";
import { type TbTestType } from "../types";

interface InstructionsStepProps {
  testType: TbTestType;
  onNext: () => void;
  onBack: () => void;
}

export function InstructionsStep(props: InstructionsStepProps) {
  const { testType, onNext, onBack } = props;

  const checklistItems = getTbTestChecklist(testType);

  return (
    <>
      <DialogContent>
        <Stack gap={8}>
          <Text variant="h3">Upload TB test result</Text>

          <Card outlined variant="quaternary">
            <CardContent>
              <Stack direction="row" gap={3} alignItems="flex-start">
                <CbhIcon type="lightbulb-gray" size="medium" />
                <Text variant="body2">{TB_TEST_UPLOAD_CALLOUT}</Text>
              </Stack>
            </CardContent>
          </Card>

          <Stack gap={3}>
            <Text variant="body1" sx={{ fontWeight: "bold" }}>
              TB test result must include
            </Text>

            <Card variant="tertiary">
              <CardContent>
                <List disablePadding>
                  {checklistItems.map((item) => (
                    <ListItem key={item} sx={{ paddingY: 1 }}>
                      <ListItemIcon iconType="checkmark" />
                      <ListItemText primary={<Text variant="body2">{item}</Text>} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          size="large"
          variant="contained"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onNext}
        >
          Upload
        </Button>
      </DialogFooter>
    </>
  );
}
